import IntegrationsBaseController from 'cio/controllers/integrations';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

export default class IntegrationsWarehouseBigQueryController extends IntegrationsBaseController {
  @service account!: AccountService;

  bigqueryImage = new URL('cio/assets/images/integrations/bigquery.svg', import.meta.url).toString();
  googleCloudStorageImage = new URL(
    'cio/assets/images/integrations/google-cloud-storage.svg',
    import.meta.url,
  ).toString();

  get showPremiumLabel() {
    return this.account.planFeatures.warehouseSync.showPremiumLabel;
  }
}
